export const DATETIME_VALIDATION_KEY: string = "datetimeValidation";
export const DISABLE_FUTURE_DATES_KEY: string = "disableFutureDates";

export interface DateTimeValidation {
  validate: DateTimeValidationFunction;
  validationName: string;
  compareWith: string;
  requiredVariable?: string;
}

enum DateTimeValidationType {
  after = "after",
}

type DateTimeValidationFunction = (value: string, compareTo: string) => boolean;

const dateTimeValidations = {
  after: (value: string, compareTo: string) => {
    return new Date(value).getTime() > new Date(compareTo).getTime();
  },
};

export const validationTypeToFunction: {
  [key in DateTimeValidationType as string]: DateTimeValidationFunction;
} = {
  [DateTimeValidationType.after]: dateTimeValidations.after,
};

export const getDateTimeValidations = (
  fieldProps: any
): DateTimeValidation[] => {
  return Object.entries(fieldProps)
    .filter(([key, _]) => key.startsWith(DATETIME_VALIDATION_KEY))
    .map(([key, value]) => {
      const validationType = key.split(".")[1];
      const validate = validationTypeToFunction[validationType];

      const valueAsString = value as string;
      const requiredVariable = valueAsString.startsWith("$")
        ? valueAsString.substring(2, valueAsString.length - 1)
        : undefined;

      return {
        validate,
        compareWith: value as string,
        requiredVariable,
        validationName: key,
      };
    });
};
